.dropdown {
  // to arrange the dropdown above the offers' links
  position: relative;
  z-index: 5;
}
